import React from "react";
import { NavLink } from "react-router-dom";
import web from "../images/brands/DLF_logo.svg";
import work1 from "../images/brands/vtp.png";
import work2 from "../images/brands/tvs-emerald.png";
import work3 from "../images/brands/DLF.svg";
import work4 from "../images/brands/gaur.png";
import MonitorIcon from "@mui/icons-material/Monitor";
import TabletMacIcon from "@mui/icons-material/TabletMac";
import TerminalIcon from "@mui/icons-material/Terminal";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import BrushIcon from "@mui/icons-material/Brush";
import CampaignIcon from "@mui/icons-material/Campaign";
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop";
import NotesIcon from "@mui/icons-material/Notes";

import about from "../images/about.jpg";

import house from "../images/icons/house.svg";
import travel_case from "../images/icons/travel-case.svg";
import video_tutorials from "../images/icons/video-tutorials.svg";
import taxi from "../images/icons/taxi.svg";
import event from "../images/icons/event.svg";
import smartphone from "../images/icons/smartphone.svg";
import joystick from "../images/icons/joystick.svg";
import healthcare from "../images/icons/healthcare.svg";
import money_growth from "../images/icons/money-growth.svg";
import baker from "../images/icons/baker.svg";
import mobile_app from "../images/icons/mobile-app.svg";
import groceries from "../images/icons/groceries.svg";

const Home = () => {
  return (
    <>
      <section className="sec_1">
        <div className="header_height sec_bg d-flex align-items-center">
          <div className="container">
            <div className="col-12 col-md-9 col-lg-6 py-5">
              <h1 className="hdrcolor">
                Welcome to Byteskull: Unleash Your Digital Potential
              </h1>
              <p className="text-white lead">
                Transforming Visions into Digital Reality.
              </p>
              <NavLink className="nav-link" to="/contact">
                <button className="btn btn-lg col-lg-4 col-6 btn_custom btn_shadow">
                  LET'S TALK
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mx-auto py-5">
          <div className="mb-4 text-center">
            <h1 className="display-6 mb-1">Our Expertise</h1>
            <p className="text-muted">
              We specialize in crafting exceptional digital experiences that
              elevate businesses and organizations to new heights.
            </p>
          </div>
          <div className="row gy-5 d-flex align-items-center justify-content-evenly mt-0">
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/0`}
                >
                  <div className="shp">
                    <MonitorIcon />
                  </div>
                  <p className="mb-2 mt-4">Web Development</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Crafting responsive, user-friendly websites that leave a
                    lasting impact.
                  </p>
                </NavLink>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/1`}
                >
                  <div className="shp">
                    <TabletMacIcon />
                  </div>
                  <p className="mb-2 mt-4">Application Development</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Building innovative mobile and web applications for diverse
                    needs.
                  </p>
                </NavLink>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/2`}
                >
                  <div className="shp">
                    <TerminalIcon />
                  </div>
                  <p className="mb-2 mt-4">Software Development</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Developing tailored software solutions to solve specific
                    business challenges.
                  </p>
                </NavLink>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/3`}
                >
                  <div className="shp">
                    <CloudQueueIcon />
                  </div>
                  <p className="mb-2 mt-4">Cloud Computing</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Leveraging the power of the cloud to enhance your
                    operations.
                  </p>
                </NavLink>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/4`}
                >
                  <div className="shp">
                    <BrushIcon />
                  </div>
                  <p className="mb-2 mt-4">Graphic Designing</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Creating visually captivating assets that resonate with your
                    audience.
                  </p>
                </NavLink>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/5`}
                >
                  <div className="shp">
                    <CampaignIcon />
                  </div>
                  <p className="mb-2 mt-4">Digital Marketing</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Promoting businesses through effective online marketing
                    strategies.
                  </p>
                </NavLink>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/6`}
                >
                  <div className="shp">
                    <ScreenSearchDesktopIcon />
                  </div>
                  <p className="mb-2 mt-4">SEO</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Optimizing your online presence for better visibility and
                    reach.
                  </p>
                </NavLink>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center mb-4">
              <div
                className="shadow-sm position-relative rounded pt-5 pb-3 px-3 border"
                style={{ height: "220px" }}
              >
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/7`}
                >
                  <div className="shp">
                    <NotesIcon />
                  </div>
                  <p className="mb-2 mt-4">Content Marketing</p>
                  <p className="text-muted text-left text-xl-center text-lg-center">
                    Developing and promoting strategic content to engage and
                    inform.
                  </p>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container my-5">
          <div className="row flex-md-row about-section">
            <div className="col-12 col-md-6 py-5">
              <div className="image-container text-center">
                <img className="img-fluid rounded shadow" src={about} alt="" />
              </div>
            </div>
            <div className="col-12 col-md-6 py-5">
              <div className="text-md-start">
                <h1 className="display-6 mb-4">About Us</h1>
                <p className="text-muted">
                  Our mission is to revolutionize industries through
                  cutting-edge digital solutions that empower businesses to
                  thrive in the modern landscape. We envision a future where
                  innovation and technology drive sustainable growth and
                  efficiency.
                </p>
                <p className="text-muted">
                  Our mission and vision intertwine, shaping a path that leads
                  to transformative results and enduring partnerships. As we
                  pave the way for a digitally empowered future, we're dedicated
                  to being the catalyst that propels businesses towards their
                  full potential.
                </p>
                <NavLink
                  className="nav-link px-0"
                  to="/about"
                  style={{ width: "120px" }}
                >
                  <button className="btn btn_custom">Read more</button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*start we serve*/}
      <section>
        <div className="container mx-auto py-5 my-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="page-headings text-center">
                <h1 className="display-6 mb-1">
                  Serving a Diverse Range of Industries
                </h1>
                <p className="text-muted">
                  Our design journey is guided by a tried-and-true methodology.
                  We kickstart the process by immersing ourselves in a thorough
                  comprehension of your unique requirements, shaping a
                  meticulous planning framework from the outset.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt30">
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={house} alt="Real Estate Industry" />
                <h6>Real estate</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={travel_case} alt="Tour &amp; Travels Industry" />
                <h6>Tour &amp; Travels</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={video_tutorials} alt="img" />
                <h6>Education</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={taxi} alt="Transport Industry" />
                <h6>Transport</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={event} alt="Event Organising Industry" />
                <h6>Event</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={smartphone} alt="E-Commerce Industry" />
                <h6>eCommerce</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={joystick} alt="Game Industry" />
                <h6>Game</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={healthcare} alt="Healthcare Industry" />
                <h6>Healthcare</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={money_growth} alt="Finance Industry" />
                <h6>Finance</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={baker} alt="Restaurant Industry" />
                <h6>Restaurant</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={mobile_app} alt="On-Demand Industry" />
                <h6>On-Demand</h6>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-6">
              <div className="industry-workfor shadow-sm">
                <img src={groceries} alt="Grocery Industry" />
                <h6>Grocery</h6>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*we serve end*/}

      <section className="sec_2">
        <div className="sec_bg py-5">
          <div className="container d-flex justify-content-center align-items-center">
            <div className="col-12 col-md-9 col-lg-6 text-center py-3">
              <h1 className="display-6 mb-1 text-white">Our Brand Partner</h1>
              <img
                className="image-fluid py-3"
                alt="brand"
                width="40%"
                src={web}
              />
              <p className="text-white lead">
                Byteskull proudly stands as a brand partner alongside the
                innovation leader, DLF.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section> 
			<div className="container mx-auto py-5">
				<div className="mb-5 text-center">
					<p className="display-6 mb-1">Our Products</p>
					<p className="text-muted">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
				</div>
				<div className="row gy-3 d-flex align-items-center justify-content-evenly">
					<div className="col-md-3 text-center">
						<div className="snip1534">
							<img className="img-fluid" alt="product1"  src={product1} />
							<div className="img_caption">
								<h6>Demo Product</h6>
							</div>
						</div>
					</div>
					<div className="col-md-3 text-center">
						<div className="snip1534">
							<img className="img-fluid" alt="product2" src={product1} />
							<div className="img_caption">
								<h6>Demo Product</h6>
							</div>
						</div>
					</div>
					<div className="col-md-3 text-center">
						<div className="snip1534">
							<img className="img-fluid" alt="product3" src={product1} />
							<div className="img_caption">
								<h6>Demo Product</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section> */}

      <section className="bg-light">
        <div className="container mx-auto py-5">
          <div className="mb-5 text-center">
            <h1 className="display-6 mb-1">Our Clients</h1>
            <p className="text-muted">
              Our clients are at the heart of our digital endeavors, driving us
              to create exceptional solutions that exceed expectations.
            </p>
          </div>
          <div className="row gy-2 brands_logo d-flex align-items-center justify-content-evenly col-md-7 m-auto">
            <div className="col-md-3 col-4 col-lg-4 text-center">
              <img className="img-fluid" alt="company1" src={work1} />
            </div>
            <div className="col-md-3 col-4 col-lg-4 text-center">
              <img className="img-fluid" alt="company2" src={work2} />
            </div>
            <div className="col-md-3 col-4 col-lg-4 text-center">
              <img className="img-fluid" alt="company3" src={work3} />
            </div>
            <div className="col-md-3 col-4 col-lg-4 text-center">
              <img className="img-fluid" alt="company4" src={work4} />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="py-5">
          <div className="container d-flex justify-content-center align-items-center">
            <div className="col-12 col-md-9 col-lg-6 py-5 text-center">
              <h1 className="display-6 mb-1">
                Let's Connect and Create Together
              </h1>
              <p className="text-muted">
                We're excited to connect with you at Byteskull! Whether you're
                ready to kickstart a new project, have questions about our
                services, or simply want to explore the possibilities, we're
                here to help.
              </p>
              <NavLink className="nav-link" to="/contact">
                <button className="btn p-2 btn_custom col-lg-3 col-md-5 col-6">
                  GET IN TOUCH
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
